import type { FeatureItem } from "../LoginGuidePopup/LoginGuideContent/types";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/GuidePopup/constants";

const I18n = I18nUtil.createScoped(Translations);

export const LoginGuideFeatures = (): FeatureItem[] => [
  { name: I18n.t("More searches"), enabled: true },
  { name: I18n.t("Access to Edgen 360° Reports"), enabled: true },
  { name: I18n.t("Powerful trading tools"), enabled: true },
  { name: I18n.t("Extra Aura"), enabled: true },
];
